
export const LOCAL_STORAGE_WALLET_TYPE = 'CHIMP_APP_WALLET_TYPE';
export const LOCAL_STORAGE_ACCESS_TOKEN = 'ACCESS_TOKEN';
export const LOCAL_STORAGE_REFRESH_TOKEN = 'REFRESH_TOKEN ';
export const LOCAL_STORAGE_CART = 'CART';
export const LOCAL_STORAGE_ORDER_ID = 'ORDER_ID';
export const LOCAL_STORAGE_THEME_MODE = 'CRONOS_CHIMPS_THEME';
